import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiRoutes } from '../../shared/constants/routes';
import { SystemMessage } from '../models/system-message.model';

/** A backend that predates `closable` and `actions` sends neither. */
type SystemMessageResponse = Omit<SystemMessage, 'closable' | 'actions'> & Partial<Pick<SystemMessage, 'closable' | 'actions'>>;

function withDefaults(message: SystemMessageResponse): SystemMessage {
  return { ...message, closable: message.closable !== false, actions: message.actions ?? [] };
}

@Injectable({ providedIn: 'root' })
export class SystemMessageService {
  private readonly httpClient = inject(HttpClient);

  /** Every announcement whose visibility window covers now. Empty when there is nothing to show. */
  public getActive(): Observable<SystemMessage[]> {
    return this.httpClient
      .get<SystemMessageResponse[]>(ApiRoutes.systemMessages.active)
      .pipe(map((messages) => messages.map(withDefaults)));
  }
}
